import { EnvironmentInterface } from './environment.interface';

export const environment: EnvironmentInterface = {
  production: true,
  apiUrl: 'https://api.kidfl.de',
  shopUrl: 'https://kinder-ferienlager.com',
};
